import { useState } from "react"

type SortValue = string | number | null | undefined

export function useKnowledgeTableSort<T, Field extends string>(
  data: T[] | undefined,
  columns: Record<Field, (row: T) => SortValue>,
) {
  const [sort, setSort] = useState<{ field: Field; direction: "asc" | "desc" }>()

  const sortedData = sort
    ? [...(data ?? [])].sort((left, right) => {
        const leftValue = columns[sort.field](left)
        const rightValue = columns[sort.field](right)

        if (leftValue == null) return rightValue == null ? 0 : 1
        if (rightValue == null) return -1

        const comparison =
          typeof leftValue === "number" && typeof rightValue === "number"
            ? leftValue - rightValue
            : String(leftValue).localeCompare(String(rightValue))

        return sort.direction === "asc" ? comparison : -comparison
      })
    : (data ?? [])

  function sortable(field: Field) {
    return {
      active: sort?.field === field,
      direction: sort?.field === field ? sort.direction : ("asc" as const),
      onClick: () =>
        setSort((current) => ({
          field,
          direction: current?.field === field && current.direction === "asc" ? "desc" : "asc",
        })),
    }
  }

  return { sortedData, sortable }
}
